import {combineReducers} from 'redux';

import create from './program-create/reducer';
import edit from './program-instance/program-edit/reducer';
import index from './programs-index/reducer';
import instance from './program-instance/program-general/reducer';
import organizations from './program-instance/program-organizations/reducer';

export default combineReducers({index, create, instance, edit, organizations});
